<!-- Desktop. -->
<div
	class="container-fluid schedule-container schedule-desktop"
	style="margin-bottom: 20px"
	(window:resize)="onResize()"
>
	<div class="row">
		<financial-report-looker> </financial-report-looker>
		<!-- Show appointment details. -->
		<app-details
			*ngIf="!isMobile && modalVisible === 1"
			[activeSidebar]="activeSidebar"
			(showEvents)="changeActiveSidebar($event)"
			(rescheduleEvent)="reschedule($event)"
		></app-details>

		<!-- Show form modal -->
		<appointment-sidebar
		></appointment-sidebar>
	</div>
</div>
